import dayjs from 'dayjs';

export const convertToHalfWidth = (s: string) => {
  return s
    .replaceAll(/[\uFF01-\uFF5E]/g, fullWidthChar =>
      String.fromCodePoint((fullWidthChar.codePointAt(0) ?? 0) - 0xfe_e0),
    )
    .replaceAll('\u3000', '\u0020')
    .replaceAll(/[ー]/g, '-'); // hyphen filter holder of label
};

export const formatCharacter = (string_: string) => {
  return string_
    .replaceAll(/[“”]/g, '"')
    .replaceAll(/[‘’]/g, "'")
    .replaceAll(/[•]/g, '·');
};

export const trimAllStringEnds = (object: unknown): unknown => {
  if (dayjs.isDayjs(object)) {
    return object;
  }
  if (typeof object === 'string') {
    return object.trimEnd();
  }
  if (Array.isArray(object)) {
    return object.map((item: unknown) => trimAllStringEnds(item));
  }
  if (typeof object === 'object' && object !== null) {
    const trimmedObject: Record<string, unknown> = {};
    for (const key in object) {
      const value = (object as Record<string, unknown>)[key];
      trimmedObject[key] = trimAllStringEnds(value);
    }
    return trimmedObject;
  }
  return object;
};

// fix for https://wlc-poc.atlassian.net/browse/TAG4-3165
export function transformEmojisIfHave(string: string) {
  // transform emoji character into normal character
  return '*'.repeat(string?.length);
}
